import { UserLocaleEnum } from 'collections/users';

export enum AiWriterModalFormFieldEnum {
  SourceMessage = 'sourceMessage',
  Instructions = 'instructions',
  ImprovedMessage = 'improvedMessage',
  Locale = 'locale',
  ProofReadingLocale = 'proofReadingLocale',
  ProofReading = 'proofReading',
}

export interface AiWriterModalFormValues {
  [AiWriterModalFormFieldEnum.SourceMessage]: string;
  [AiWriterModalFormFieldEnum.Instructions]: string;
  [AiWriterModalFormFieldEnum.ImprovedMessage]: string;
  [AiWriterModalFormFieldEnum.Locale]: UserLocaleEnum;
  [AiWriterModalFormFieldEnum.ProofReadingLocale]: UserLocaleEnum;
  [AiWriterModalFormFieldEnum.ProofReading]: string;
}
